import { combineReducers } from "redux";
import actionTypes from "../actions/actionTypes";
import loginReducer from "./loginReducer";
import commonReducer from "./commonReducer";
import manageReducer from "./manageReducer";
import adminReducer from "./adminReducer/adminReducer";
import socialReducer from "./socialReducer";
import reportReducer from "./reportReducer";
import errorReducer from "./errorReducer";
import eventReducer from "./eventReducer";
import myQueryReducer from "./adminReducer/myQueryReducer";
import distributeReducer from "./distributeReducer";
import organizeReducer from "./organizeReducer";

const appReducer = combineReducers({
  commonReducer,
  loginReducer,
  manageReducer,
  eventReducer,
  adminReducer,
  reportReducer,
  socialReducer,
  errorReducer,
  myQueryReducer,
  distributeReducer,
  organizeReducer,
});
const rootReducer = (state, action) => {
  const { type } = action;
  if (type === actionTypes.loginTypes.LOGOUT) state = undefined;
  return appReducer(state, action);
};

export default rootReducer;
